/* ASBEA STUDIOS — theme JS (vanilla, no dependencies) */
(function () {
  'use strict';

  var R = (window.ASBEA && window.ASBEA.routes) || {};
  var S = (window.ASBEA && window.ASBEA.strings) || {};

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function ajaxRoute(url, fallback) {
    url = url || fallback;
    return url.indexOf('.js') === -1 ? url + '.js' : url;
  }

  function formatMoney(cents) {
    var fmt = (window.ASBEA && window.ASBEA.moneyFormat) || '€{{amount_with_comma_separator}}';
    var value = (cents / 100).toFixed(2);
    if (fmt.indexOf('comma_separator') !== -1) {
      value = value.replace('.', ',');
      value = value.replace(/\B(?=(\d{3})+(?!\d))/g, function (m, o, str) { return str.indexOf(',') === -1 ? '.' : '.'; });
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* ----------------------------------------------------------------------
     Mobile navigation
     ---------------------------------------------------------------------- */
  function initMobileNav() {
    var nav = $('[data-mobile-nav]');
    if (!nav) return;
    $$('[data-mobile-nav-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var open = nav.classList.toggle('is-open');
        document.body.style.overflow = open ? 'hidden' : '';
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ----------------------------------------------------------------------
     Accordions
     ---------------------------------------------------------------------- */
  function initAccordions() {
    $$('.accordion__head').forEach(function (head) {
      head.addEventListener('click', function () {
        head.closest('.accordion__item').classList.toggle('is-open');
      });
    });
  }

  /* ----------------------------------------------------------------------
     Scroll reveal
     ---------------------------------------------------------------------- */
  function initReveal() {
    var items = $$('.reveal');
    if (!items.length || !('IntersectionObserver' in window)) {
      items.forEach(function (i) { i.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    items.forEach(function (i) { io.observe(i); });
  }

  /* ----------------------------------------------------------------------
     Marquee — duplicate content so the loop is seamless
     ---------------------------------------------------------------------- */
  function initMarquee() {
    $$('.marquee__track').forEach(function (track) {
      if (track.dataset.cloned) return;
      track.dataset.cloned = '1';
      track.innerHTML = track.innerHTML + track.innerHTML;
    });
  }

  /* ----------------------------------------------------------------------
     Cart drawer
     ---------------------------------------------------------------------- */
  var Drawer = {
    el: null,
    open: function () {
      if (!this.el) this.el = $('[data-cart-drawer]');
      if (!this.el) return;
      this.el.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    },
    close: function () {
      if (!this.el) this.el = $('[data-cart-drawer]');
      if (!this.el) return;
      this.el.classList.remove('is-open');
      document.body.style.overflow = '';
    },
    render: function (html) {
      var target = $('[data-cart-drawer-content]');
      if (!target) return;
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var fresh = parsed.querySelector('[data-cart-drawer-content]');
      if (fresh) target.innerHTML = fresh.innerHTML;
      var count = parsed.querySelector('[data-cart-count]');
      $$('[data-cart-count]').forEach(function (n) {
        if (count) n.textContent = count.textContent;
      });
      bindCartEvents();
    },
    refresh: function () {
      var self = this;
      return fetch(R.cart_url + '?section_id=cart-drawer', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.text(); })
        .then(function (html) { self.render(html); });
    }
  };

  function bindCartEvents() {
    $$('[data-qty-change]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var line = btn.dataset.line;
        var input = $('input[data-line="' + line + '"]');
        var delta = parseInt(btn.dataset.qtyChange, 10);
        var next = Math.max(0, parseInt(input.value, 10) + delta);
        updateLine(line, next);
      });
    });

    $$('[data-line-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () { updateLine(btn.dataset.lineRemove, 0); });
    });

    $$('input[data-line]').forEach(function (input) {
      input.addEventListener('change', function () {
        updateLine(input.dataset.line, Math.max(0, parseInt(input.value, 10) || 0));
      });
    });
  }

  function updateLine(line, quantity) {
    var panel = $('[data-cart-drawer-content]');
    if (panel) panel.style.opacity = '0.5';
    fetch(ajaxRoute(R.cart_change_url, '/cart/change'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: quantity })
    })
      .then(function () { return Drawer.refresh(); })
      .then(function () {
        var p = $('[data-cart-drawer-content]');
        if (p) p.style.opacity = '';
        if (document.body.classList.contains('template-cart')) window.location.reload();
      })
      .catch(function () {
        var p = $('[data-cart-drawer-content]');
        if (p) p.style.opacity = '';
      });
  }

  function initDrawerTriggers() {
    $$('[data-cart-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        Drawer.open();
      });
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-close]')) { e.preventDefault(); Drawer.close(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') Drawer.close();
    });
    bindCartEvents();
  }

  /* ----------------------------------------------------------------------
     Product form — variant selection + AJAX add to cart
     ---------------------------------------------------------------------- */
  function initProductForms() {
    $$('[data-product-form]').forEach(function (form) {
      var root = form.closest('[data-product-root]') || document;
      var teaserMode = root.dataset && root.dataset.teaserMode === 'true';
      var teaserEl = $('[data-teaser]', root);
      var dataEl = $('[data-variants]', form.closest('[data-product-root]') || document);
      var variants = [];
      try { variants = JSON.parse(dataEl.textContent); } catch (err) { variants = []; }

      var idInput = $('[data-variant-id]', form);
      var priceEl = $('[data-price]', form.closest('[data-product-root]') || document);
      var submit = $('[data-add-to-cart]', form);

      function selectedOptions() {
        return $$('input[type="radio"]:checked', form)
          .sort(function (a, b) { return parseInt(a.dataset.optionIndex, 10) - parseInt(b.dataset.optionIndex, 10); })
          .map(function (i) { return i.value; });
      }

      function matchVariant() {
        var chosen = selectedOptions();
        return variants.filter(function (v) {
          return v.options.every(function (o, i) { return o === chosen[i]; });
        })[0];
      }

      function updateAvailability() {
        // Grey out size values that have no available variant for the chosen colour
        var chosen = selectedOptions();
        $$('input[type="radio"]', form).forEach(function (input) {
          var idx = parseInt(input.dataset.optionIndex, 10);
          if (idx === 0) return;
          var test = chosen.slice();
          test[idx] = input.value;
          var match = variants.filter(function (v) {
            return v.options.every(function (o, i) { return i > idx ? true : o === test[i]; });
          })[0];
          input.disabled = teaserMode ? false : !(match && match.available);
        });
      }

      function refresh() {
        var v = matchVariant();
        if (!v) {
          submit.disabled = true;
          submit.textContent = teaserMode ? (S.comingSoon || 'Coming soon') : (S.unavailable || 'Unavailable');
          if (teaserEl) teaserEl.hidden = !teaserMode;
          return;
        }
        if (idInput) idInput.value = v.id;
        if (priceEl) {
          priceEl.innerHTML = v.compare_at_price && v.compare_at_price > v.price
            ? '<s>' + formatMoney(v.compare_at_price) + '</s> ' + formatMoney(v.price)
            : formatMoney(v.price);
        }
        submit.disabled = !v.available;
        if (v.available) {
          submit.textContent = S.addToCart || 'Add to cart';
        } else {
          submit.textContent = teaserMode ? (S.comingSoon || 'Coming soon') : (S.soldOut || 'Sold out');
        }
        if (teaserEl) teaserEl.hidden = v.available;

        var media = $('[data-variant-media="' + v.id + '"]');
        if (media) media.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });

        if (window.history.replaceState && v.id) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      $$('input[type="radio"]', form).forEach(function (input) {
        input.addEventListener('change', function () {
          var label = $('[data-selected-for="' + input.name + '"]');
          if (label) label.textContent = input.value;
          updateAvailability();
          refresh();
        });
      });

      updateAvailability();
      refresh();

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        submit.disabled = true;
        var original = submit.textContent;
        submit.textContent = '...';
        fetch(ajaxRoute(R.cart_add_url, '/cart/add'), { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status) throw new Error(res.description || res.message);
            return Drawer.refresh();
          })
          .then(function () {
            submit.textContent = original;
            submit.disabled = false;
            Drawer.open();
          })
          .catch(function (err) {
            submit.textContent = original;
            submit.disabled = false;
            alert(err.message || S.cartError || 'Something went wrong');
          });
      });
    });
  }

  /* ----------------------------------------------------------------------
     Collection sort
     ---------------------------------------------------------------------- */
  function initSort() {
    var sel = $('[data-sort]');
    if (!sel) return;
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  function init() {
    initMobileNav();
    initAccordions();
    initReveal();
    initMarquee();
    initDrawerTriggers();
    initProductForms();
    initSort();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init inside the theme editor
  document.addEventListener('shopify:section:load', init);
})();

/* ==========================================================================
   Newsletter pop-up
   --------------------------------------------------------------------------
   Timing follows the evidence on intrusiveness: never immediately (Nielsen
   Norman Group's work on modal interruption), and never twice for someone who
   already said no. Dismissal is remembered locally, so the pop-up stays gone
   for the number of days set in the theme editor.
   ========================================================================== */
(function () {
  'use strict';

  var KEY = 'asbea:popup-dismissed';

  function seen(days) {
    try {
      var until = window.localStorage.getItem(KEY);
      return until && Number(until) > Date.now();
    } catch (e) {
      return false; // storage blocked — behave as if not yet seen
    }
  }

  function remember(days) {
    try {
      window.localStorage.setItem(KEY, String(Date.now() + days * 864e5));
    } catch (e) { /* nothing to do */ }
  }

  function init() {
    var pop = document.querySelector('[data-popup]');
    if (!pop) return;

    var days = parseInt(pop.dataset.days, 10) || 30;
    var delay = (parseInt(pop.dataset.delay, 10) || 0) * 1000;
    var exit = pop.dataset.exit === 'true';
    var opened = false;

    // A successful signup renders inside the pop-up, so show it straight away.
    var success = pop.querySelector('.notice');
    if (success) { show(); remember(days); return; }

    if (seen(days)) return;

    function show() {
      if (opened) return;
      opened = true;
      pop.hidden = false;
      requestAnimationFrame(function () { pop.classList.add('is-open'); });
      document.removeEventListener('mouseout', onExit);
    }

    function hide() {
      pop.classList.remove('is-open');
      remember(days);
      window.setTimeout(function () { pop.hidden = true; }, 350);
    }

    function onExit(e) {
      if (!e.relatedTarget && e.clientY <= 0) show();
    }

    window.setTimeout(show, delay);
    if (exit) document.addEventListener('mouseout', onExit);

    pop.addEventListener('click', function (e) {
      if (e.target.closest('[data-popup-close]')) { e.preventDefault(); hide(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !pop.hidden) hide();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
